import React from 'react';
import { Route, Switch } from 'react-router-dom';
import NavBar from './NavBar';
import { ProfilePage, AlertsPage, UsersPage, AccountPage } from '../admin/AdminPages';
import NavToTop from 'feature/nav/NavToTop';
import { ManageEdition } from '../admin/content/manageedition';

export default function PerformAdminRouter(props) {
  return (
    <>
      <NavBar hide={props.hide} changeRealm={props.changeRealm} realm={props.realm} pageTitle={props.title} pageValue={props.match.params.base || false} />
      <NavToTop />
      <Switch>
        <Route exact path="/profile" render={(match) => <ProfilePage changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/alerts" render={(match) => <AlertsPage changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/alerts/:display" render={(match) => <AlertsPage changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/users" render={(match) => <UsersPage changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/users/:display" render={(match) => <UsersPage changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/account/content/edition/:id" render={(match) => <ManageEdition changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/account" render={(match) => <AccountPage changeTitle={props.changeTitle} {...match} />} />
        <Route exact path="/account/:display" render={(match) => <AccountPage changeTitle={props.changeTitle} {...match} />} />
      </Switch>
    </>
  );
}
